import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["layout", "backgroundColor", "palette", "eyebrow", "title", "body", "actionBar", "media", "smallMedia", "cornersStyle", "trackEvent", "trackExperimentEvent"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { BREAKPOINTS } from "../../constants/design";
import { Device } from "../../constants/device";
import { onTrackItemClickEvent } from "../../util/tracking";
import { useCallback, useMemo } from 'react';
import { ButtonSize } from "../button";
import RenderHtml from "../render-html";
import useMediaWithDevice from "../../hooks/use-media-with-device";
import { Body, ContentContainerGridItem, Eyebrow, MediaTextModuleContainer, MediaTextGrid, MediaContainerGridItem, MediaTextActionBar, Title } from "./media-text-module.styles";
import { defaultProps, testIds } from "./constants";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var MediaTextModule = function MediaTextModule(_ref) {
  var layout = _ref.layout,
    backgroundColor = _ref.backgroundColor,
    palette = _ref.palette,
    eyebrow = _ref.eyebrow,
    title = _ref.title,
    body = _ref.body,
    actionBar = _ref.actionBar,
    media = _ref.media,
    smallMedia = _ref.smallMedia,
    cornersStyle = _ref.cornersStyle,
    trackEvent = _ref.trackEvent,
    trackExperimentEvent = _ref.trackExperimentEvent,
    rest = _objectWithoutProperties(_ref, _excluded);
  var isSmallScreen = useMediaWithDevice("(max-width: ".concat(BREAKPOINTS.md - 1, "px)"), Device.Mobile);
  var handleActionClick = useCallback(function (_ref2) {
    var link = _ref2.link;
    onTrackItemClickEvent(link, trackEvent, trackExperimentEvent);
  }, [trackEvent, trackExperimentEvent]);
  var renderedMediaContainer = useMemo(function () {
    return /*#__PURE__*/_jsx(MediaContainerGridItem, {
      "data-testid": testIds.Media,
      layout: layout,
      media: media,
      smallMedia: smallMedia
    });
  }, [media, smallMedia, layout]);
  var renderedTitle = useMemo(function () {
    if (!title) {
      return null;
    }
    if (typeof title === 'string') {
      return /*#__PURE__*/_jsx(RenderHtml, {
        as: "span",
        html: title
      });
    }
    return title;
  }, [title]);
  return /*#__PURE__*/_jsx(MediaTextModuleContainer, _objectSpread(_objectSpread({
    "data-testid": testIds.Container,
    layout: layout,
    palette: palette,
    backgroundColor: backgroundColor,
    cornersStyle: cornersStyle
  }, rest), {}, {
    children: /*#__PURE__*/_jsxs(MediaTextGrid, {
      children: [!isSmallScreen && renderedMediaContainer, /*#__PURE__*/_jsxs(ContentContainerGridItem, {
        "data-testid": testIds.Content,
        layout: layout,
        children: [eyebrow && /*#__PURE__*/_jsx(Eyebrow, {
          "data-testid": testIds.Eyebrow,
          children: eyebrow
        }), /*#__PURE__*/_jsx(Title, {
          "data-testid": testIds.Title,
          children: renderedTitle
        }), isSmallScreen && renderedMediaContainer, /*#__PURE__*/_jsx(Body, {
          "data-testid": testIds.Body,
          forwardedAs: typeof body !== 'string' ? 'div' : undefined,
          children: body
        }), actionBar && /*#__PURE__*/_jsx(MediaTextActionBar, _objectSpread(_objectSpread({}, actionBar), {}, {
          "data-testid": testIds.ActionBar,
          size: ButtonSize.Large,
          palette: palette,
          onClick: handleActionClick
        }))]
      })]
    })
  }));
};
MediaTextModule.defaultProps = defaultProps;
export default MediaTextModule;